<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M15.01953125,5C15.01953125,3.34,13.67953125,2,12.01953125,2C10.35953125,2,9.01953125,3.34,9.01953125,5C9.01953125,6.66,10.35953125,8,12.01953125,8C12.22953125,8,12.42953125,7.98,12.61953125,7.94C12.09953125,9.76,11.13953125,11,10.01953125,11C9.46953125,11,9.01953125,11.45,9.01953125,12C9.01953125,12.55,9.46953125,13,10.01953125,13C12.77953125,13,15.01953125,9.870000000000001,15.01953125,6C15.01953125,5.8,14.99953125,5.609999999999999,14.97953125,5.42C14.98953125,5.279999999999999,15.01953125,5.140000000000001,15.01953125,5C15.01953125,5,15.01953125,5,15.01953125,5ZM4.01953125,2C2.35953125,2,1.01953125,3.34,1.01953125,5C1.01953125,6.66,2.35953125,8,4.01953125,8C4.22953125,8,4.42953125,7.98,4.61953125,7.94C4.09953125,9.76,3.13953125,11,2.01953125,11C1.46953125,11,1.01953125,11.45,1.01953125,12C1.01953125,12.55,1.46953125,13,2.01953125,13C4.77953125,13,7.01953125,9.870000000000001,7.01953125,6C7.01953125,5.8,6.99953125,5.609999999999999,6.97953125,5.42C6.98953125,5.279999999999999,7.01953125,5.140000000000001,7.01953125,5C7.01953125,3.34,5.66953125,2,4.01953125,2C4.01953125,2,4.01953125,2,4.01953125,2Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Citation',
} as DefineComponent
</script>
